import formatsIndex from '@/assets/formats/index'
import getFormatById from '@/assets/formats/get-format-by-id'
const Site = {
  install: function (Vue, options) {
    Vue.prototype.$site = {
      name: process.env.VUE_APP_SITE_NAME,
      id: process.env.VUE_APP_SITE_ID,
      isDevelop: process.env.NODE_ENV === 'development',
      isProduction: process.env.NODE_ENV === 'production',
      blogJsonUrl: process.env.VUE_APP_BLOG_RSS_JSON_URL,
      formatsIndex: formatsIndex,
      getFormatById: getFormatById
    }
  }
}
export default Site
